import { useState } from "react"
import "../Styles/Signup.css"
import { Input, PasswordInput, TextInput } from '@mantine/core';
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo3.jpg"

const PasswordReset = () => {
    const [details, setDetails] = useState({
        password: "",
        confirmPassword: ""
    })

    const navigate = useNavigate()
    return<>
        <section className="signup">
            <div className="signupWrapper">
                <img src={logo} alt="" />
                <form action="">
                    <div className="formHeading">
                        <h2>Reset Password</h2>
                        <p>Reset your farmcart password</p>
                    </div>

                    <div className="inputContainer">
                        <PasswordInput
                            withAsterisk
                            label= "New Password"
                            description="Please enter a strong password"
                            placeholder="*******"
                            value={details["password"]}
                            onChange={(e) => setDetails({...details, password: e.target.value})}
                        />
                        <PasswordInput
                            withAsterisk
                            label= "Confirm Password"
                            description="confirm your password"
                            placeholder="*******"
                            value={details["confirmPassword"]}
                            onChange={(e) => setDetails({...details, confirmPassword: e.target.value})}
                        />
                    </div>
                    <div className="buttonWrap">
                        <button className="btn">Reset Password</button>
                        <button className="btn2" onClick={() => navigate("/signin")}>Cancel</button>

                    </div>
                </form>
            </div>
        </section>
    </>

}

export default PasswordReset